import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnCM: CultureInfo = {
  name: 'ff-Latn-CM',
  displayName: 'Pulaar (Latn, Kameruun)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-CM',
  parent: CultureInfoFfLatn
};
